import { Button } from "../../ui";
import type { FeedbackFilter } from "../hooks";

const FILTERS: Array<{ label: string; value: FeedbackFilter }> = [
  { label: "Open", value: "open" },
  { label: "All", value: "all" },
  { label: "Resolved", value: "resolved" },
];

type FeedbackFiltersProps = {
  value: FeedbackFilter;
  onChange: (value: FeedbackFilter) => void;
};

export function FeedbackFilters({ value, onChange }: FeedbackFiltersProps) {
  return (
    <div className="flex gap-2">
      {FILTERS.map((item) => (
        <Button
          key={item.value}
          size="sm"
          variant={value === item.value ? "primary" : "secondary"}
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </Button>
      ))}
    </div>
  );
}
